<div class="flex h-full w-full flex-col" *transloco="let t">
  <div class="mb-2 flex w-full items-center justify-end gap-2">
    @if (withDelete()) {
      <button iButton variant="destructive" (click)="deleteClicked.emit()" testId="btn-delete-asins">
        <IIcon name="trash" />
        {{ t("common.delete") }}
      </button>
    }
    @if (withMove()) {
      <button iButton variant="secondary" (click)="moveClicked.emit()">
        <IIcon name="chevronsRight" />
        {{ t("common.move") }}
      </button>
    }
    @if (withEdit()) {
      <button iButton variant="secondary" (click)="editClicked.emit()" testId="btn-add-products">
        <IIcon name="edit" />
        {{ t("common.edit") }}
      </button>
    }
    @if (withAdd()) {
      <button iButton variant="secondary" (click)="addClicked.emit()" testId="btn-add-products">
        <IIcon name="add" />
        {{ t("common.add") }}
      </button>
    }
  </div>
  <div class="min-h-0 flex-1">
    <ng-content></ng-content>
  </div>
</div>
